module.exports = __webpack_public_path__ + "img/1-1.f2c8b32b.jpg";